import { useEffect, useRef, useState } from "react";
import { MdAdd, MdAddCircle, MdAddCircleOutline, MdAllInbox, MdArrowBack, MdCalendarMonth, MdCircle, MdClose, MdDrafts, MdFileCopy, MdInbox, MdMail, MdMenu, MdSend, MdViewSidebar } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import axios from "axios";
import { Dialog, DialogActions, DialogContent, Button, DialogContentText, DialogTitle, Box } from "@mui/material";
import { useMediaQuery } from "react-responsive";
import { researcherMailConst, web_url } from "../../constant";
import { useWebSocket } from "../../websocket_context";


function EmailInbox({ t, number, lang }) {
    const isXlOrLarger = useMediaQuery({ minWidth: 1270 });
    const [openError, setOpenError] = useState(false);
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false)

    const penpalEmail = localStorage.getItem('penpalEmail');
    const teacherEmail = localStorage.getItem('teacherEmail');
    const adminMail = researcherMailConst;

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setError(t('t93'));
        } else if (err.toLowerCase().includes('found')) {
            setError(t('t214'));
        } else {
            setError(t('t94'));
        }
        setOpenError(true);
    };

    const handleCloseError = () => {
        setOpenError(false);
    };
    const [searchInput, setSearchInput] = useState("");
    const navigate = useNavigate();

    const [mailsInbox, setMailsInbox] = useState([]);

    const [mailsSent, setMailsSent] = useState([]);

    const [mailsDraft, setMailsDraft] = useState([]);
    const [date, setDate] = useState(null)

    const [showCloseIcon, setShowCloseIcon] = useState(null)
    const messageIdsSet = useRef(new Set());
    const [isDataLoaded, setIsDataLoaded] = useState(false);

    const [numberOfUnread, setNumberOfUnread] = useState(0);

    useEffect(() => {
        // console.log('techer email',teacherEmail);

        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();
        if (logDetails) {
            setIsLoading(true);

            const configToken = {
                headers: {
                    'Authorization': `Bearer ${logDetails.token}`,
                },
            };
            axios.get(`${web_url}/api/email-threads/participants/${logDetails.email}`, configToken).then((response) => {

                try {

                    let allMessages = response.data.flatMap(thread =>
                        thread.messages.map(message => ({
                            ...message,
                            threadId: thread.threadId,
                            subject: thread.subject || " ",
                            initialSender: thread.messages[0].sender,
                            translatedSubject: thread.translatedSubject || " ",
                            sentAt: formatDate(message.sentAt),
                            sentAtOriginal: formatDateNew(message.sentAt),
                            other: thread.participants.find(email => email !== message.sender) || null,
                            isRead: thread.participantsStatus
                                ? thread.participantsStatus.find(person => person.email === logDetails.email)?.isRead ?? true
                                : true
                        }))
                    );

                    allMessages.sort((a, b) => new Date(b.sentAt.replace(/-/g, "/")) - new Date(a.sentAt.replace(/-/g, "/")));

                    const sentMessages = allMessages.filter(msg => msg.sender === (logDetails.email) && msg.isDraft === "FALSE");
                    let draftMessages = allMessages.filter(msg => msg.sender === (logDetails.email) && msg.isDraft === "TRUE");

                    const receivedMessages2 = allMessages
                        .filter(msg => msg.sender !== logDetails.email && msg.isDraft === "FALSE" && msg.status === "APPROVED")
                        .reduce((acc, msg) => {
                            if (!acc[msg.threadId] || new Date(msg.sentAt) > new Date(acc[msg.threadId].sentAt)) {
                                acc[msg.threadId] = msg;
                            }
                            return acc;
                        }, {});

                    const receivedMessages = Object.values(receivedMessages2);

                    setMailsDraft(draftMessages);
                    setMailsInbox(receivedMessages);
                    setMailsSent(sentMessages);
                    setNumberOfUnread(receivedMessages.filter(msg => !msg.isRead).length);
                    receivedMessages.forEach(msg => messageIdsSet.current.add(msg.messageId));
                    sentMessages.forEach(msg => messageIdsSet.current.add(msg.messageId));
                    draftMessages.forEach(msg => messageIdsSet.current.add(msg.messageId));
                    setIsDataLoaded(true);

                    if (!isXlOrLarger) {
                        if (receivedMessages.length === 0 && sentMessages.length === 0 && draftMessages.length === 0) {
                            const mailRequest = {
                                type: 'new',
                                subject: 'nothing'
                            };
                            localStorage.setItem('threadId', JSON.stringify(mailRequest));
                            navigate('/mobile/student/mailbox/composemail');
                        }
                    }
                } catch (e) {
                    console.log(e);
                }


                setIsLoading(false);

            }).catch((err) => {
                setIsLoading(false);
                handleClickOpenError("error occured");
            })
        }
    }, [localStorage.getItem('refresh')])

    const { subscribeToTopic } = useWebSocket();

    useEffect(() => {
        if (!isDataLoaded) return;
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();

        subscribeToTopic((data) => {
            if (!data.participants.includes(logDetails.email)) return;
            const responseBody = data;
            let messages = responseBody.messages.map(message => ({
                ...message,
                threadId: responseBody.threadId,
                subject: responseBody.subject || " ",
                initialSender: responseBody.messages[0].sender,
                translatedSubject: responseBody.translatedSubject || " ",
                sentAt: formatDate(message.sentAt),
                sentAtOriginal: formatDateNew(message.sentAt),
                other: responseBody.participants.find(email => email !== message.sender) || null,
                isRead: responseBody.participantsStatus
                    ? responseBody.participantsStatus.find(person => person.email === logDetails.email)?.isRead ?? true
                    : true
            }));

            messages.sort((a, b) => new Date(b.sentAt.replace(/-/g, "/")) - new Date(a.sentAt.replace(/-/g, "/")));

            const sentMessages = messages.filter(msg => msg.sender === (logDetails.email) && msg.isDraft === "FALSE");
            let draftMessages = messages.filter(msg => msg.sender === (logDetails.email) && msg.isDraft === "TRUE");

            const receivedMessages2 = messages
                .filter(msg => msg.sender !== logDetails.email && msg.isDraft === "FALSE" && msg.status === "APPROVED")
                .reduce((acc, msg) => {
                    if (!acc[msg.threadId] || new Date(msg.sentAt) > new Date(acc[msg.threadId].sentAt)) {
                        acc[msg.threadId] = msg;
                    }
                    return acc;
                }, {});

            const receivedMessages = Object.values(receivedMessages2);

            const uniqueReceivedMessages = receivedMessages.filter(msg => {
                if (messageIdsSet.current.has(msg.messageId)) return false;
                messageIdsSet.current.add(msg.messageId);
                return true;
            });

            const uniqueSentMessages = sentMessages.filter(msg => {
                if (messageIdsSet.current.has(msg.messageId)) return false;
                messageIdsSet.current.add(msg.messageId);
                return true;
            });

            const uniqueDraftMessages = draftMessages.filter(msg => {
                if (messageIdsSet.current.has(msg.messageId)) return false;
                messageIdsSet.current.add(msg.messageId);
                return true;
            });
            setNumberOfUnread(prev => prev + uniqueReceivedMessages.filter(msg => !msg.isRead).length);
            setMailsDraft(prev => [...prev, ...uniqueDraftMessages]);
            setMailsInbox(prev => [...prev, ...uniqueReceivedMessages]);
            setMailsSent(prev => [...prev, ...uniqueSentMessages]);
        });

    }, [isDataLoaded]);

    useEffect(() => {
        if (date !== null) {
            setShowCloseIcon(true)
        } else {
            setShowCloseIcon(false)
        }
    }, [date])

    const filteredEmailsInbox = (mailsInbox ?? []).filter((mail) =>
        (
            (mail.body?.toLowerCase() || '') + (mail.subject?.toLowerCase() || '')
        ).includes(searchInput.toLowerCase()) &&
        (!date || mail.sentAt?.startsWith(date))
    );

    const filteredEmailsSent = (mailsSent ?? []).filter((mail) =>
        ((mail.body?.toLowerCase() || '') + (mail.subject?.toLowerCase() || '')).includes(searchInput.toLowerCase()) &&
        (!date || mail.sentAt?.startsWith(date)) // Ensure sentAt is not null
    );

    const filteredEmailsDraft = (mailsDraft ?? []).filter((mail) =>
        ((mail.body?.toLowerCase() || '') + (mail.subject?.toLowerCase() || '')).includes(searchInput.toLowerCase()) &&
        (!date || mail.sentAt?.startsWith(date)) // Check if date matches
    );


    const value = number ?? 10;

    const [folderSelected, setFolderSelected] = useState(
        () => {
            let selected = localStorage.getItem('folder') ? parseInt(localStorage.getItem('folder'), 10) : 4;

            if (!isXlOrLarger && selected === 4) {
                selected = 5;
            }

            if (selected === 0) {
                return {
                    sent: false,
                    inbox: true,
                    draft: false,
                    rejected: false,
                    compose_new: false,
                }
            } else if (selected === 1) {
                return {
                    sent: true,
                    inbox: false,
                    draft: false,
                    rejected: false,
                    compose_new: false,
                }
            } else if (selected === 2) {
                return {
                    sent: false,
                    inbox: false,
                    draft: true,
                    rejected: false,
                    compose_new: false,
                }
            } else if (selected === 4) {
                return {
                    sent: false,
                    inbox: false,
                    draft: false,
                    rejected: false,
                    compose_new: true,
                }
            } else {
                return {
                    sent: false,
                    inbox: true,
                    draft: false,
                    rejected: false,
                    compose_new: false,
                }
            }
        }
    )

    const formatDate = (timestamp) => {
        const dateObj = new Date(timestamp);

        // Convert to IST (UTC + 5:30)
        // const istOffset = 0; 
        const istOffset = 5.5 * 60 * 60 * 1000; // 5.5 hours in milliseconds
        const istTime = new Date(dateObj.getTime() + istOffset);

        // Use .getFullYear(), .getMonth(), etc., instead of .getUTC*
        const year = istTime.getFullYear();
        const month = String(istTime.getMonth() + 1).padStart(2, "0"); // Ensure 2 digits
        const day = String(istTime.getDate()).padStart(2, "0"); // Ensure 2 digits
        const hours = String(istTime.getHours()).padStart(2, "0"); // Corrected
        const minutes = String(istTime.getMinutes()).padStart(2, "0"); // Corrected
        const sec = String(istTime.getSeconds()).padStart(2, "0"); // Corrected

        // console.log("old", timestamp);
        // console.log("new", `${year}-${month}-${day} ${hours}:${minutes}:${sec}`);

        return `${year}-${month}-${day} ${hours}:${minutes}:${sec}`;
    }

    const handleInboxMailReadClick = (mail) => {
        setIsLoading(true);
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();


        const configToken = {
            headers: {
                'Authorization': `Bearer ${logDetails.token}`,
            },
        };
        axios.patch(`${web_url}/api/email-threads/${mail.threadId}/${logDetails.email}/read?threadReadStatus=true`, {}, configToken).then((r) => {
            setIsLoading(false);
            if (isXlOrLarger) {
                localStorage.setItem('mailreceived', JSON.stringify(mail));
                localStorage.removeItem('maildraft');
                localStorage.removeItem('mailsent');
                localStorage.setItem('composenewclicked', 'false');
                navigate('/desktop/student/mailbox/view');
            } else {
                localStorage.setItem('mailreceived', JSON.stringify(mail));
                localStorage.removeItem('maildraft');
                localStorage.removeItem('mailsent');
                localStorage.setItem('composenewclicked', 'false');
                navigate('/mobile/student/mailbox/view')
            };
        }).catch((e) => {
            setIsLoading(false);
            handleClickOpenError('error occured')
        })

    }

    const formatDateNew = (timestamp) => {
        return new Date(timestamp).toISOString(); // Ensures cross-browser compatibility
    };

    const getLogDetails = () => {
        return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
    };
    const logDetails = getLogDetails();

    const [nowReading, setNowReading] = useState(() => {
        const number = localStorage.getItem('nowreading') ? parseInt(localStorage.getItem('nowreading'), 10) : 100000;
        return number;
    });

    const [openNavBar, setOpenNavBar] = useState(false);

    /** tweak or fetch dynamically */
    const handleFolderSelect = (folderKey, folderIndex) => {
        setNowReading(10000);
        localStorage.setItem("folder", folderIndex);
        setFolderSelected({
            sent: folderKey === "sent",
            inbox: folderKey === "inbox",
            draft: folderKey === "draft",
            compose_new: false,
        });
        if (folderKey === 'inbox') setHeadingKey('t230');
        else if (folderKey === 'sent') setHeadingKey('t231');
        else if (folderKey === 'draft') setHeadingKey('t232');
        setOpenNavBar(false);
    };

    const [headingKey, setHeadingKey] = useState('t230');

    const navItems = [
        { label: t('t230'), onClick: () => handleFolderSelect("inbox", 0), icon: <MdMail size={20} className="inline-block mr-2" /> },
        { label: t('t231'), onClick: () => handleFolderSelect("sent", 1), icon: <MdSend size={20} className="inline-block mr-2" /> },
        { label: t('t232'), onClick: () => handleFolderSelect("draft", 2), icon: <MdFileCopy size={20} className="inline-block mr-2" /> },
    ];

    useEffect(() => {
        if (date !== null) {
            setShowCloseIcon(true)
        } else {
            setShowCloseIcon(false)
        }
    }, [date])

    const [openMobileCalendar, setOpenMobileCalendar] = useState(false);
    const [openDesktopCalendar, setOpenDesktopCalendar] = useState(false);
    return (
        <div className="mb-[100px] lg:mb-[130px] xl:mb-[20px]">

            <div className="pl-[20px] pr-[20px] md:pl-[30px] md:pr-[30px] xl:pr-[5px] md:items-center pt-[80px] md:pt-[120px] lg:pt-[140px] xl:pt-[20px] 2xl:pt-[25px]">
                {
                    isLoading ?
                        <div className="items-center justify-center flex pt-[30px]">
                            <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                        </div>
                        :
                        <div className="md:mx-[30px] lg:mx-[100px] xl:mx-[60px]">
                            <>
                                <aside
                                    className={`fixed inset-y-0 left-0 z-30 w-64 md:w-[500px] bg-white text-[#1E2533] transform transition-transform duration-300 ${openNavBar ? "translate-x-0" : "-translate-x-full"
                                        } xl:hidden`}
                                >
                                    {/* <div className="flex h-16 items-center justify-center border-b border-gray-700 text-2xl font-bold"></div> */}
                                    <nav className="space-y-3 px-4 py-6 mt-[20px]">
                                        {navItems.map(({ label, onClick, icon }, index) => {
                                            const active =
                                                (index === 0 && folderSelected.inbox) ||
                                                (index === 1 && folderSelected.sent) ||
                                                (index === 2 && folderSelected.draft);
                                            return (
                                                <button
                                                    key={index}
                                                    onClick={onClick}
                                                    className={`font-semibold block w-full rounded px-4 py-2 text-left transition ${active
                                                        ? 'bg-[#E0E8EE] '
                                                        : ''}`}
                                                >
                                                    {icon} {label}
                                                </button>
                                            )
                                        })}
                                    </nav>
                                </aside>

                                {/* dim background */}
                                {openNavBar && (
                                    <div
                                        className="fixed inset-0 z-20 bg-black/40 xl:hidden"
                                        onClick={() => setOpenNavBar(false)}
                                    />
                                )}

                                {/* Grid layout with button + search */}
                                <div className="xl:hidden mt-4 grid grid-cols-7 gap-[10px] w-full">
                                    <div className="bg-[#0E141F] rounded-xl items-center justify-center flex">
                                        <button
                                            onClick={() => setOpenNavBar(!openNavBar)}
                                            className="rounded-full "
                                        >
                                            <MdMenu size={28} color="white" />
                                        </button>
                                    </div>
                                    <div className="col-span-6">
                                        <input
                                            type="search"
                                            placeholder={t("t228")}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            value={searchInput}
                                            className={`p-2 md:p-3 lg:p-4 xl:p-1 2xl:p-2 border border-gray-300 rounded-md w-full text-black text-[15px] md:text-[18px] ${lang === "en" ? "placeholder:text-[15px] md:placeholder:text-[17px] lg:placeholder:text-[19px] xl:placeholder:text-[15px] 2xl:placeholder:text-[17px]" : (lang === "si" ? "placeholder:text-[14px] md:placeholder:text-[16px] lg:placeholder:text-[16px] xl:placeholder:text-[13px] 2xl:placeholder:text-[15px]" : "placeholder:text-[14px] md:placeholder:text-[15px] lg:placeholder:text-[16px] xl:placeholder:text-[13px] 2xl:placeholder:text-[15px]")}`}
                                        />
                                    </div>
                                </div>
                            </>

                            <div className="xl:hidden w-full h-[40px] md:w-[350px] xl:w-[200px] md:h-[50px] xl:h-[40px] flex justify-center items-center text-[90px] md:text-[22px] xl:text-[16px] md:mr-[10px] min-w-[100px] rounded-md px-[2px] py-[0px] md:py-[10px] md:px-[20px] xl:py-[1px] xl:px-[10px]  border border-1 mt-[10px] border-gray-400 text-gray-700 bg-[#F1F6FB]">
                                <LocalizationProvider dateAdapter={AdapterDayjs}>

                                    <DatePicker
                                        value={date ? dayjs(date) : null}
                                        onChange={(date) => {
                                            if (date) {
                                                if (date) {
                                                    const formattedDate = dayjs(date).format('YYYY-MM-DD');
                                                    setDate(formattedDate)
                                                }
                                            }
                                        }}
                                        format="YYYY-MM-DD"
                                        open={openMobileCalendar} // this will open calendar programmatically
                                        onClose={() => setOpenMobileCalendar(false)}
                                        components={{
                                            OpenPickerIcon: () => null,
                                        }}
                                        slotProps={{
                                            textField: {
                                                InputProps: {
                                                    style: {
                                                        border: 'none',
                                                        fontSize: '15px',
                                                        color: '#000000',
                                                        fontFamily: 'Urbanist',
                                                    },
                                                    endAdornment: null
                                                },
                                                placeholder: t('t229'),
                                                fullWidth: true,
                                                sx: {

                                                    '& .MuiOutlinedInput-root': {
                                                        border: 'none', // Remove outer border
                                                        boxShadow: 'none', // Remove shadow
                                                    },
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        border: 'none', // Remove outlined border
                                                    },
                                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                                        border: 'none', // Remove hover effect
                                                    },
                                                    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                        border: 'none', // Remove focus effect
                                                    },
                                                    '& input::placeholder': {
                                                        color: '#6B7280',
                                                        opacity: 1, // for consistent appearance in Firefox
                                                        fontSize: {
                                                            xs: lang === 'en' ? '15px' : lang === "si" ? '19px' : '17px',
                                                            sm: lang === 'en' ? '16px' : lang === "si" ? '21px' : '18px',
                                                            md: lang === 'en' ? '19px' : lang === "si" ? '21px' : '19px',
                                                            lg: lang === 'en' ? '16px' : lang === "si" ? '17px' : '15px',
                                                            xl: lang === 'en' ? '16px' : lang === "si" ? '18px' : '18px'
                                                        },
                                                    },
                                                },
                                            },
                                        }}
                                    />

                                </LocalizationProvider>

                                {
                                    !showCloseIcon &&
                                    <MdCalendarMonth
                                        size="30px"
                                        className="text-gray-500 ml-[10px] hover:cursor-pointer rounded-full focus:outline-none hover:ring-2 hover:ring-offset-2 hover:ring-gray-300 active:ring-2 active:ring-gray-400 active:ring-offset-2 transition duration-150 ease-in-out"
                                        onClick={() => setOpenMobileCalendar(true)}
                                        tabIndex={0}
                                        role="button"
                                    />
                                }
                                {
                                    showCloseIcon && <MdClose onClick={() => setDate(null)} size="30px" className="2xl:block text-gray-500 ml-[5px]" />
                                }
                            </div>

                            <div className="hidden xl:flex w-full gap-[15px] justify-evenly">
                                <button className={`w-full hidden xl:flex items-center justify-center gap-[10px] ${lang === "en" ? "xl:text-[16px] 2xl:text-[20px]" : (lang === "si" ? "xl:text-[13px] 2xl:text-[15px]" : "xl:text-[13px] 2xl:text-[16px]")} rounded-md xl:py-[10px] 2xl:py-[14px] border border-1  border-[#0E141F] font-[600] bg-[#0E141F] text-[#ffffff]`}
                                    onClick={() => {
                                        localStorage.setItem("folder", 4);
                                        setFolderSelected({ sent: false, inbox: false, draft: false, compose_new: true })
                                        const mailRequest = {
                                            type: 'new',
                                            subject: 'nothing'
                                        };
                                        localStorage.setItem('threadId', JSON.stringify(mailRequest));
                                        localStorage.setItem('composenewclicked', 'true');
                                        navigate('/desktop/student/mailbox')
                                    }}><MdAddCircleOutline size={19} />{t('t233')}</button>
                                <button className={`w-full hidden xl:flex items-center justify-center gap-[10px] ${lang === "en" ? "xl:text-[16px] 2xl:text-[20px]" : (lang === "si" ? "xl:text-[13px] 2xl:text-[15px]" : "xl:text-[13px] 2xl:text-[16px]")} rounded-md xl:py-[10px] 2xl:py-[14px] border border-1 border-[#0E141F] font-[600] ${folderSelected.inbox ? 'bg-[#EFF4F7] text-[#1E2533]' : 'bg-transparent text-[#1E2533]'}`} onClick={() => { setNowReading(10000); localStorage.setItem("folder", 0); setFolderSelected({ sent: false, inbox: true, draft: false, compose_new: false }) }} ><MdMail size={19} />{t('t230')}</button>
                                <button className={`w-full hidden xl:flex items-center justify-center gap-[10px] ${lang === "en" ? "xl:text-[16px] 2xl:text-[20px]" : (lang === "si" ? "xl:text-[13px] 2xl:text-[15px]" : "xl:text-[13px] 2xl:text-[16px]")} rounded-md xl:py-[10px] 2xl:py-[14px] border border-1 border-[#0E141F] font-[600] ${folderSelected.sent ? 'bg-[#EFF4F7] text-[#1E2533]' : 'bg-transparent text-[#1E2533]'}`} onClick={() => { setNowReading(10000); localStorage.setItem("folder", 1); setFolderSelected({ sent: true, inbox: false, draft: false, compose_new: false }) }}><MdSend size={19} />{t('t231')}</button>
                                <button className={`w-full hidden xl:flex items-center justify-center gap-[10px] ${lang === "en" ? "xl:text-[16px] 2xl:text-[20px]" : (lang === "si" ? "xl:text-[13px] 2xl:text-[15px]" : "xl:text-[13px] 2xl:text-[16px]")} rounded-md xl:py-[10px] 2xl:py-[14px] border border-1  border-[#0E141F] font-[600] ${folderSelected.draft ? 'bg-[#EFF4F7] text-[#1E2533]' : 'bg-transparent text-[#1E2533]'}`} onClick={() => { setNowReading(10000); localStorage.setItem("folder", 2); setFolderSelected({ sent: false, inbox: false, draft: true, compose_new: false }) }}><MdFileCopy size={19} />{t('t232')}</button>
                            </div>
                            <div className="flex flex-col w-full bg-[#F7FAFB] mt-[10px] rounded-sm">
                                <div className="xl:hidden flex flex-col  justify-start mt-[20px]">
                                    <p className={`text-start font-bold ml-[10px] text-[#1E2533] ${lang === "en" ? "text-[22px] md:text-[26px] lg:text-[32px] xl:text-[27px] 2xl:text-[28px]" : (lang === "si" ? "text-[16px] md:text-[20px] lg:text-[23px] xl:text-[22px] 2xl:text-[18px]" : "text-[15px] md:text-[21px] lg:text-[22px] xl:text-[20px] 2xl:text-[18px]")}`}>
                                        {t(headingKey)}
                                    </p>
                                    {
                                        ((folderSelected?.inbox && filteredEmailsInbox.length === 0) || (folderSelected.sent && filteredEmailsSent.length === 0) || (folderSelected.draft && filteredEmailsDraft.length === 0)) &&
                                        <div className={`text-center ml-[10px] mt-[20px]  text-[#6D7986] ${lang === "en" ? "text-[14px] md:text-[18px] lg:text-[24px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[15px] lg:text-[19px] xl:text-[13px] 2xl:text-[18px]" : "text-[12px] md:text-[16px] lg:text-[19px] xl:text-[13px] 2xl:text-[18px]")}`}>{t('t456')}</div>
                                    }
                                    {
                                        (folderSelected?.inbox && filteredEmailsInbox.length !== 0 ) &&
                                        <>
                                            {
                                                lang === "si" ?
                                                    <div className={`text-start ml-[10px] mt-[5px]  text-[#6D7986] ${lang === "en" ? "text-[14px] md:text-[18px] lg:text-[23px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[16px] lg:text-[19px] xl:text-[13px] 2xl:text-[18px]" : "text-[12px] md:text-[16px] lg:text-[19px] xl:text-[13px] 2xl:text-[18px]")}`}>{t('t473')}{filteredEmailsInbox.length} {t('t457_2')},{t('t457')} {numberOfUnread}{t('t457_2')} </div> :
                                                    <div className={`text-start ml-[10px] mt-[5px]  text-[#6D7986] ${lang === "en" ? "text-[14px] md:text-[18px] lg:text-[23px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[16px] lg:text-[19px] xl:text-[13px] 2xl:text-[18px]" : "text-[12px] md:text-[16px] lg:text-[19px] xl:text-[13px] 2xl:text-[18px]")}`}>{filteredEmailsInbox.length} {t('t473')}, {numberOfUnread} {t('t457')}</div>
                                            }
                                        </>

                                    }
                                </div>

                                <div className="xl:hidden">
                                    {
                                        folderSelected.inbox &&
                                        <div className="mt-[13px] md:mt-6">
                                            {filteredEmailsInbox
                                                .slice()
                                                .sort((a, b) => new Date(b.sentAtOriginal).getTime() - new Date(a.sentAtOriginal).getTime())
                                                .map((mail, index) => (
                                                    <div key={index} className={`border border-t-[#C6CFD7] border-t-[1px] border-x-0 border-b-0 cursor-pointer flex flex-col ${mail.isRead === false ? '' : (nowReading === index ? 'bg-[#FEFBE8]' : '')}  px-[10px] pt-[10px] pb-[20px]`}
                                                        onClick={() => {
                                                            localStorage.setItem('nowreading', index);
                                                            handleInboxMailReadClick(mail)
                                                        }}
                                                    >
                                                        <div className="flex justify-between">
                                                            <div className="flex items-center justify-start gap-[5px]">
                                                                {
                                                                    mail.isRead === false &&
                                                                    <MdCircle size={10} className={`fill-[#1CB789]`} />
                                                                }
                                                                <p className={`${mail.isRead === false ? "text-black" : "text-[#6D7986]"} ${lang === "en" ? "text-[12px] md:text-[20px] lg:text-[24px] xl:text-[15px] 2xl:text-[17px]" : (lang === "si" ? "text-[12px] md:text-[18px] lg:text-[22px] xl:text-[15px] 2xl:text-[17px]" : "text-[12px] md:text-[19px] lg:text-[22px] xl:text-[15px] 2xl:text-[17px]")} font-bold`}>{mail.sender === adminMail ? "Admin" : (mail.sender === teacherEmail ? "Teacher" : (mail.sender === penpalEmail ? "Penpal" : "Old penpal"))}</p>
                                                            </div>
                                                            <p className={`${mail.isRead === false ? "text-black" : "text-[#6D7986]"} text-[12px] md:text-[17px] lg:text-[19px] xl:text-[15px] 2xl:text-[17px]`}>{mail.sentAt.slice(0, -3)}</p>
                                                        </div>
                                                        <div className={`md:hidden mt-[3px] ${mail.isRead === false ? "text-black" : "text-[#6D7986]"} ${lang === "en" ? "text-[15px] md:text-[22px] lg:text-[27px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[20px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]" : "text-[13px] md:text-[18px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]")}`}>
                                                            {
                                                                logDetails &&
                                                                <>
                                                                    {
                                                                        (mail.type === "PENPAL") && mail.initialSender !== logDetails.email ?

                                                                            <p>{mail.translatedSubject.trim() !== "" ?
                                                                                (mail.translatedSubject.length > 30
                                                                                    ? `${mail.translatedSubject.slice(0, 30)}...`
                                                                                    : mail.translatedSubject) : "(No subject)"}</p>

                                                                            :
                                                                            <p>{mail.subject.trim() !== "" ?
                                                                                (mail.subject.length > 30
                                                                                    ? `${mail.subject.slice(0, 30)}...`
                                                                                    : mail.subject) : "(No subject)"}</p>
                                                                    }
                                                                </>
                                                            }
                                                        </div>
                                                        <div className={`hidden md:block lg:hidden mt-[3px] ${mail.isRead === false ? "text-black" : "text-[#6D7986]"} ${lang === "en" ? "text-[15px] md:text-[22px] lg:text-[27px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[20px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]" : "text-[13px] md:text-[18px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]")}`}>

                                                            {
                                                                logDetails &&
                                                                <>
                                                                    {
                                                                        mail.type === "PENPAL" && mail.initialSender !== logDetails.email ?
                                                                            <p>{mail.translatedSubject.trim() !== "" ?
                                                                                (mail.translatedSubject.length > 60
                                                                                    ? `${mail.translatedSubject.slice(0, 60)}...`
                                                                                    : mail.translatedSubject) : "(No subject)"}</p>
                                                                            :
                                                                            <p>{mail.subject.trim() !== "" ?
                                                                                (mail.subject.length > 60
                                                                                    ? `${mail.subject.slice(0, 60)}...`
                                                                                    : mail.subject) : "(No subject)"}</p>
                                                                    }
                                                                </>
                                                            }
                                                        </div>
                                                        <div className={`hidden lg:block xl:hidden mt-[3px] ${mail.isRead === false ? "text-black" : "text-[#6D7986]"} ${lang === "en" ? "text-[15px] md:text-[22px] lg:text-[25px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[20px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]" : "text-[13px] md:text-[18px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]")}`}>
                                                            {
                                                                logDetails &&
                                                                <>
                                                                    {
                                                                        mail.type === "PENPAL" && mail.initialSender !== logDetails.email ?
                                                                            <p>{mail.translatedSubject.trim() !== "" ?
                                                                                (mail.translatedSubject.length > 70
                                                                                    ? `${mail.translatedSubject.slice(0, 70)}...`
                                                                                    : mail.translatedSubject) : "(No subject)"}</p>
                                                                            :
                                                                            <p>{mail.subject.trim() !== "" ?
                                                                                (mail.subject.length > 70
                                                                                    ? `${mail.subject.slice(0, 70)}...`
                                                                                    : mail.subject) : "(No subject)"}</p>
                                                                    }
                                                                </>
                                                            }
                                                        </div>
                                                    </div>
                                                ))}

                                        </div>
                                    }
                                    {
                                        folderSelected.sent &&
                                        <div className="mt-[13px] md:mt-6">
                                            {filteredEmailsSent
                                                .slice()
                                                .sort((a, b) => new Date(b.sentAtOriginal).getTime() - new Date(a.sentAtOriginal).getTime())
                                                .map((mail, index) => (
                                                    <div key={index} className={`border border-t-[#C6CFD7] border-t-[1px] border-x-0 border-b-0 cursor-pointer flex flex-col ${(nowReading === index ? 'bg-[#FEFBE8]' : '')} md:mb-[15px] px-[10px] pt-[10px] pb-[20px]`}
                                                        onClick={() => {
                                                            localStorage.setItem('nowreading', index);
                                                            localStorage.setItem('mailsent', JSON.stringify(mail));
                                                            localStorage.removeItem('maildraft');
                                                            localStorage.removeItem('mailreceived');
                                                            localStorage.setItem('composenewclicked', 'false');
                                                            navigate('/mobile/student/mailbox/view');
                                                        }}>
                                                        <div className="flex justify-between">
                                                            <p className={`text-black ${lang === "en" ? "text-[12px] md:text-[20px] lg:text-[24px] xl:text-[15px] 2xl:text-[17px]" : (lang === "si" ? "text-[12px] md:text-[18px] lg:text-[22px] xl:text-[15px] 2xl:text-[17px]" : "text-[12px] md:text-[19px] lg:text-[22px] xl:text-[15px] 2xl:text-[17px]")} font-bold`}>{mail.other === adminMail ? "Admin" : (mail.other === teacherEmail ? "Teacher" : (mail.other === penpalEmail ? "Penpal" : "Old penpal"))}</p>
                                                            <p className={`text-black text-[12px] md:text-[17px] lg:text-[19px] xl:text-[15px] 2xl:text-[17px]`}>{mail.sentAt.slice(0, -3)}</p>
                                                        </div>
                                                        <div className={`md:hidden mt-[3px] ${lang === "en" ? "text-black text-[15px] md:text-[22px] lg:text-[27px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[20px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]" : "text-[13px] md:text-[18px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]")}`}>
                                                            {
                                                                logDetails &&
                                                                <>
                                                                    {
                                                                        mail.type === "PENPAL" && mail.initialSender !== logDetails.email ?
                                                                            <p>{mail.translatedSubject.trim() !== "" ?
                                                                                (mail.translatedSubject.length > 30
                                                                                    ? `${mail.translatedSubject.slice(0, 30)}...`
                                                                                    : mail.translatedSubject) : "(No subject)"}</p>
                                                                            :
                                                                            <p>{mail.subject.trim() !== "" ?
                                                                                (mail.subject.length > 30
                                                                                    ? `${mail.subject.slice(0, 30)}...`
                                                                                    : mail.subject) : "(No subject)"}</p>
                                                                    }
                                                                </>
                                                            }
                                                        </div>
                                                        <div className={`hidden md:block lg:hidden mt-[3px] ${lang === "en" ? "text-black text-[15px] md:text-[22px] lg:text-[27px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[20px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]" : "text-[13px] md:text-[18px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]")}`}>
                                                            {
                                                                logDetails &&
                                                                <>
                                                                    {
                                                                        mail.type === "PENPAL" && mail.initialSender !== logDetails.email ?
                                                                            <p>{mail.translatedSubject.trim() !== "" ?
                                                                                (mail.translatedSubject.length > 60
                                                                                    ? `${mail.translatedSubject.slice(0, 60)}...`
                                                                                    : mail.translatedSubject) : "(No subject)"}</p>
                                                                            :
                                                                            <p>{mail.subject.trim() !== "" ?
                                                                                (mail.subject.length > 60
                                                                                    ? `${mail.subject.slice(0, 60)}...`
                                                                                    : mail.subject) : "(No subject)"}</p>
                                                                    }
                                                                </>
                                                            }
                                                        </div>
                                                        <div className={`hidden lg:block xl:hidden mt-[3px] ${lang === "en" ? "text-black text-[15px] md:text-[22px] lg:text-[25px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[20px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]" : "text-[13px] md:text-[18px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]")}`}>
                                                            {
                                                                logDetails &&
                                                                <>
                                                                    {
                                                                        mail.type === "PENPAL" && mail.initialSender !== logDetails.email ?
                                                                            <p>{mail.translatedSubject.trim() !== "" ?
                                                                                (mail.translatedSubject.length > 70
                                                                                    ? `${mail.translatedSubject.slice(0, 70)}...`
                                                                                    : mail.translatedSubject) : "(No subject)"}</p>
                                                                            :
                                                                            <p>{mail.subject.trim() !== "" ?
                                                                                (mail.subject.length > 70
                                                                                    ? `${mail.subject.slice(0, 70)}...`
                                                                                    : mail.subject) : "(No subject)"}</p>
                                                                    }
                                                                </>
                                                            }
                                                        </div>
                                                    </div>
                                                ))}

                                        </div>
                                    }
                                    {
                                        folderSelected.draft &&
                                        <div className="mt-[13px] md:mt-6">
                                            {filteredEmailsDraft
                                                .slice()
                                                .sort((a, b) => new Date(b.sentAtOriginal).getTime() - new Date(a.sentAtOriginal).getTime())
                                                .map((mail, index) => (
                                                    <div key={index} className={`border border-t-[#C6CFD7] border-t-[1px] border-x-0 border-b-0 cursor-pointer flex flex-col ${(nowReading === index ? 'bg-[#D9D9D9]' : '')} md:mb-[15px] px-[10px] pt-[10px] pb-[20px]`}
                                                        onClick={() => {
                                                            const mailRequest = {
                                                                type: 'draft',
                                                                threadId: mail.threadId,
                                                                subject: mail.subject,
                                                                to: mail.other,
                                                                attachments: mail.attachments,
                                                                messageId: mail.messageId,
                                                                body: mail.body,
                                                                role: mail.type
                                                            };
                                                            localStorage.setItem('threadId', JSON.stringify(mailRequest));
                                                            console.log('clicked appppi');

                                                            if (isXlOrLarger) {
                                                                navigate(`/desktop/student/mailbox/view`, { replace: true });
                                                            } else {
                                                                navigate('/mobile/student/mailbox/composemail');
                                                            }
                                                        }} >
                                                        <div className="flex justify-between">
                                                            <p className={`text-black ${lang === "en" ? "text-[12px] md:text-[20px] lg:text-[24px] xl:text-[15px] 2xl:text-[17px]" : (lang === "si" ? "text-[12px] md:text-[18px] lg:text-[22px] xl:text-[15px] 2xl:text-[17px]" : "text-[12px] md:text-[19px] lg:text-[22px] xl:text-[15px] 2xl:text-[17px]")} font-bold`}>{mail.sender === adminMail ? "Admin" : (mail.sender === teacherEmail ? "Teacher" : (mail.sender === penpalEmail ? "Penpal" : "Old penpal"))}</p>
                                                            <p className="text-black text-[12px] md:text-[17px] lg:text-[19px] xl:text-[15px] 2xl:text-[17px]">{mail.sentAt.slice(0, -3)}</p>
                                                        </div>
                                                        <div className={`md:hidden mt-[3px] ${lang === "en" ? "text-black text-[15px] md:text-[22px] lg:text-[27px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[20px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]" : "text-[13px] md:text-[18px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]")}`}>
                                                            {
                                                                logDetails &&
                                                                <>
                                                                    {
                                                                        mail.type === "PENPAL" && mail.initialSender !== logDetails.email ?
                                                                            <p>{mail.translatedSubject.trim() !== "" ?
                                                                                (mail.translatedSubject.length > 30
                                                                                    ? `${mail.translatedSubject.slice(0, 30)}...`
                                                                                    : mail.translatedSubject) : "(No subject)"}</p>
                                                                            :
                                                                            <p>{mail.subject.trim() !== "" ?
                                                                                (mail.subject.length > 30
                                                                                    ? `${mail.subject.slice(0, 30)}...`
                                                                                    : mail.subject) : "(No subject)"}</p>
                                                                    }
                                                                </>
                                                            }
                                                        </div>
                                                        <div className={`hidden md:block lg:hidden mt-[3px] ${lang === "en" ? "text-black text-[15px] md:text-[22px] lg:text-[27px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[20px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]" : "text-[13px] md:text-[18px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]")}`}>
                                                            {
                                                                logDetails &&
                                                                <>
                                                                    {
                                                                        mail.type === "PENPAL" && mail.initialSender !== logDetails.email ?
                                                                            <p>{mail.translatedSubject.trim() !== "" ?
                                                                                (mail.translatedSubject.length > 60
                                                                                    ? `${mail.translatedSubject.slice(0, 60)}...`
                                                                                    : mail.translatedSubject) : "(No subject)"}</p>
                                                                            :
                                                                            <p>{mail.subject.trim() !== "" ?
                                                                                (mail.subject.length > 60
                                                                                    ? `${mail.subject.slice(0, 60)}...`
                                                                                    : mail.subject) : "(No subject)"}</p>
                                                                    }
                                                                </>
                                                            }
                                                        </div>
                                                        <div className={`hidden lg:block xl:hidden mt-[3px] ${lang === "en" ? "text-black text-[15px] md:text-[22px] lg:text-[25px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[20px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]" : "text-[13px] md:text-[18px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]")}`}>
                                                            {
                                                                logDetails &&
                                                                <>
                                                                    {
                                                                        mail.type === "PENPAL" && mail.initialSender !== logDetails.email ?
                                                                            <p>{mail.translatedSubject.trim() !== "" ?
                                                                                (mail.translatedSubject.length > 70
                                                                                    ? `${mail.translatedSubject.slice(0, 70)}...`
                                                                                    : mail.translatedSubject) : "(No subject)"}</p>
                                                                            :
                                                                            <p>{mail.subject.trim() !== "" ?
                                                                                (mail.subject.length > 70
                                                                                    ? `${mail.subject.slice(0, 70)}...`
                                                                                    : mail.subject) : "(No subject)"}</p>
                                                                    }
                                                                </>
                                                            }
                                                        </div>
                                                    </div>
                                                ))}

                                        </div>
                                    }
                                </div>
                            </div>
                            {
                                value !== 1 && !folderSelected.compose_new ?
                                    <div className="hidden xl:block bg-[#EFF4F7] py-[20px] px-[25px] rounded-xl mt-[15px]">
                                        {
                                            (!((folderSelected?.inbox && filteredEmailsInbox.length === 0) || (folderSelected.sent && filteredEmailsSent.length === 0) || (folderSelected.draft && filteredEmailsDraft.length === 0))) &&
                                            <div className="hidden xl:grid xl:grid-cols-4  items-center justify-center gap-[10px]">
                                                <input
                                                    type="search"
                                                    placeholder={t("t228")}
                                                    onChange={(e) => setSearchInput(e.target.value)}
                                                    value={searchInput}
                                                    className={`hidden xl:block col-span-3 p-1 2xl:p-2 border border-gray-300 rounded-md w-full text-black text-[15px] md:text-[18px] ${lang === "en" ? "placeholder:text-[15px] md:placeholder:text-[17px] lg:placeholder:text-[19px] xl:placeholder:text-[15px] 2xl:placeholder:text-[17px]" : (lang === "si" ? "placeholder:text-[14px] md:placeholder:text-[16px] lg:placeholder:text-[16px] xl:placeholder:text-[13px] 2xl:placeholder:text-[15px]" : "placeholder:text-[14px] md:placeholder:text-[15px] lg:placeholder:text-[16px] xl:placeholder:text-[13px] 2xl:placeholder:text-[15px]")}`}
                                                />
                                                <div className="hidden  h-[40px] xl:flex justify-center items-center text-[90px] md:text-[22px] xl:text-[16px] md:mr-[10px] w-full rounded-md  xl:px-[10px]  border border-1  border-gray-400 text-gray-700 bg-[#F1F6FB]">
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            value={date ? dayjs(date) : null}
                                                            onChange={(date) => {
                                                                if (date) {
                                                                    if (date) {
                                                                        const formattedDate = dayjs(date).format('YYYY-MM-DD');
                                                                        setDate(formattedDate)
                                                                    }
                                                                }
                                                            }}
                                                            format="YYYY-MM-DD"
                                                            open={openDesktopCalendar} // this will open calendar programmatically
                                                            onClose={() => setOpenDesktopCalendar(false)}
                                                            components={{
                                                                OpenPickerIcon: () => null,
                                                            }}
                                                            slotProps={{
                                                                textField: {
                                                                    InputProps: {
                                                                        style: {
                                                                            border: 'none',
                                                                            fontSize: '15px',
                                                                            color: '#000000',
                                                                            fontFamily: 'Urbanist',
                                                                        },
                                                                        endAdornment: null
                                                                    },
                                                                    placeholder: t('t229'),
                                                                    fullWidth: true,
                                                                    sx: {
                                                                        '& .MuiOutlinedInput-root': {
                                                                            border: 'none', // Remove outer border
                                                                            boxShadow: 'none', // Remove shadow
                                                                        },
                                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                                            border: 'none', // Remove outlined border
                                                                        },
                                                                        '&:hover .MuiOutlinedInput-notchedOutline': {
                                                                            border: 'none', // Remove hover effect
                                                                        },
                                                                        '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                                            border: 'none', // Remove focus effect
                                                                        },
                                                                        '& input::placeholder': {
                                                                            color: '#6B7280',
                                                                            opacity: 1, // for consistent appearance in Firefox
                                                                            fontSize: {
                                                                                xs: lang === 'en' ? '15px' : lang === "si" ? '19px' : '17px',
                                                                                sm: lang === 'en' ? '16px' : lang === "si" ? '21px' : '18px',
                                                                                md: lang === 'en' ? '19px' : lang === "si" ? '21px' : '19px',
                                                                                lg: lang === 'en' ? '16px' : lang === "si" ? '17px' : '15px',
                                                                                xl: lang === 'en' ? '16px' : lang === "si" ? '18px' : '18px'
                                                                            },
                                                                        },
                                                                    },
                                                                },
                                                            }}
                                                        />
                                                    </LocalizationProvider>

                                                    {
                                                        !showCloseIcon &&
                                                        <MdCalendarMonth
                                                            size="30px"
                                                            className="text-gray-500 ml-[10px] hover:cursor-pointer rounded-full focus:outline-none hover:ring-2 hover:ring-offset-2 hover:ring-gray-300 active:ring-2 active:ring-gray-400 active:ring-offset-2 transition duration-150 ease-in-out"
                                                            onClick={() => setOpenDesktopCalendar(true)}
                                                            tabIndex={0}
                                                            role="button"
                                                        />
                                                    }
                                                    {
                                                        showCloseIcon && <MdClose onClick={() => setDate(null)} size="30px" className="cursor-pointer 2xl:block text-gray-500 ml-[5px]" />
                                                    }
                                                </div>
                                            </div>
                                        }

                                        <div className="bg-white px-[10px] py-[10px] mt-[20px]">
                                            <div className="flex flex-col  justify-start">
                                                <p className={`text-start font-bold ml-[10px] text-[#1E2533] ${lang === "en" ? "xl:text-[24px] 2xl:text-[28px]" : (lang === "si" ? "xl:text-[17px] 2xl:text-[18px]" : "xl:text-[18px] 2xl:text-[18px]")}`}>
                                                    {
                                                        folderSelected?.inbox ? t('t230') : (folderSelected.sent ? t('t231') : (folderSelected.draft ? t('t232') : t('t233')))
                                                    }
                                                </p>
                                                {
                                                    ((folderSelected?.inbox && filteredEmailsInbox.length === 0) || (folderSelected.sent && filteredEmailsSent.length === 0) || (folderSelected.draft && filteredEmailsDraft.length === 0)) &&
                                                    <div>
                                                        <img src='/images/no_mails.svg' alt="No mails" className="w-[150px] h-[150px] xl:w-[310px] xl:h-[310px] mx-auto mt-[20px] 2xl:w-[570px] 2xl:h-[570px]" />
                                                        <p className={`text-center ml-[10px] mt-[20px]  text-[#000000] font-bold ${lang === "en" ? " xl:text-[15px] 2xl:text-[18px]" : (lang === "si" ? "xl:text-[13px] 2xl:text-[15px]" : "xl:text-[13px] 2xl:text-[15px]")}`}>{t('t456')}</p>
                                                    </div>
                                                }
                                                {
                                                    (folderSelected?.inbox && filteredEmailsInbox.length !== 0 ) &&
                                                    <>
                                                        {
                                                            lang === "si" ?
                                                                <div className={`text-start ml-[10px] mt-[5px]  text-[#6D7986] ${lang === "en" ? " xl:text-[15px] 2xl:text-[18px]" : (lang === "si" ? "xl:text-[13px] 2xl:text-[15px]" : "xl:text-[13px] 2xl:text-[15px]")}`}>{t('t473')} {filteredEmailsInbox.length}{t('t457_2')}, {t('t457')} {numberOfUnread}{t('t457_2')} </div> :
                                                                <div className={`text-start ml-[10px] mt-[5px]  text-[#6D7986] ${lang === "en" ? " xl:text-[15px] 2xl:text-[18px]" : (lang === "si" ? "xl:text-[13px] 2xl:text-[15px]" : "xl:text-[13px] 2xl:text-[15px]")}`}>{filteredEmailsInbox.length} {t('t473')}, {numberOfUnread} {t('t457')}</div>
                                                        }
                                                    </>
                                                }
                                            </div>
                                            {
                                                folderSelected.inbox &&
                                                <div className="mt-6">
                                                    {filteredEmailsInbox
                                                        .slice()
                                                        .sort((a, b) => new Date(b.sentAtOriginal).getTime() - new Date(a.sentAtOriginal).getTime())
                                                        .map((mail, index) => (
                                                            <div key={index} className={`cursor-pointer flex flex-col ${mail.isRead === false ? '' : ''} bg-transparent border-t border-t-[#C6CFD7] p-[10px]`}
                                                                onClick={() => {
                                                                    localStorage.setItem('nowreading', index);
                                                                    handleInboxMailReadClick(mail)
                                                                }}
                                                            >
                                                                <div className="flex justify-between">
                                                                    <div className="flex items-center justify-start gap-[5px]">
                                                                        {
                                                                            mail.isRead === false &&
                                                                            <MdCircle size={10} className={`fill-[#1CB789]`} />
                                                                        }
                                                                        <p className={`${mail.isRead === false ? "text-black" : "text-[#6D7986]"} text-[12px] md:text-[18px] lg:text-[20px] xl:text-[15px] 2xl:text-[17px] font-bold`}>{mail.sender === adminMail ? "Admin" : (mail.sender === teacherEmail ? "Teacher" : (mail.sender === penpalEmail ? "Penpal" : "Old penpal"))}</p>
                                                                    </div>
                                                                    <p className={`${mail.isRead === false ? "text-black" : "text-[#6D7986]"} text-[12px] md:text-[17px] lg:text-[19px] xl:text-[15px] 2xl:text-[17px]`}>{mail.sentAt.slice(0, -3)}</p>
                                                                </div>
                                                                <div className={`hidden xl:block 2xl:hidden ${mail.isRead === false ? "text-black" : "text-[#6D7986]"} text-[13px] md:text-[17px] xl:text-[15px]`}>

                                                                    {
                                                                        logDetails &&
                                                                        <>
                                                                            {
                                                                                mail.type === "PENPAL" && mail.initialSender !== logDetails.email ?
                                                                                    <p>{mail.translatedSubject.trim() !== "" ?
                                                                                        (mail.translatedSubject.length > 100
                                                                                            ? `${mail.translatedSubject.slice(0, 100)}...`
                                                                                            : mail.translatedSubject) : "(No subject)"}</p>
                                                                                    :
                                                                                    <p>{mail.subject.trim() !== "" ?
                                                                                        (mail.subject.length > 100
                                                                                            ? `${mail.subject.slice(0, 100)}...`
                                                                                            : mail.subject) : "(No subject)"}</p>
                                                                            }
                                                                        </>
                                                                    }
                                                                </div>
                                                                <div className={`hidden 2xl:block ${mail.isRead === false ? "text-black" : "text-[#6D7986]"} text-[13px] md:text-[17px] xl:text-[15px]`}>

                                                                    {
                                                                        logDetails &&
                                                                        <>
                                                                            {
                                                                                mail.type === "PENPAL" && mail.initialSender !== logDetails.email ?
                                                                                    <p>{mail.translatedSubject.trim() !== "" ?
                                                                                        (mail.translatedSubject.length > 140
                                                                                            ? `${mail.translatedSubject.slice(0, 140)}...`
                                                                                            : mail.translatedSubject) : "(No subject)"}</p>
                                                                                    :
                                                                                    <p>{mail.subject.trim() !== "" ?
                                                                                        (mail.subject.length > 140
                                                                                            ? `${mail.subject.slice(0, 140)}...`
                                                                                            : mail.subject) : "(No subject)"}</p>
                                                                            }
                                                                        </>
                                                                    }
                                                                </div>
                                                            </div>
                                                        ))}

                                                </div>
                                            }
                                            {
                                                folderSelected.sent &&
                                                <div className="mt-6">
                                                    {filteredEmailsSent
                                                        .slice()
                                                        .sort((a, b) => new Date(b.sentAtOriginal).getTime() - new Date(a.sentAtOriginal).getTime())
                                                        .map((mail, index) => (
                                                            <div key={index} className="cursor-pointer flex flex-col bg-transparent border-t border-t-[#C6CFD7] p-[10px]"
                                                                onClick={() => {
                                                                    localStorage.setItem('nowreading', index);
                                                                    localStorage.setItem('mailsent', JSON.stringify(mail));
                                                                    localStorage.removeItem('maildraft');
                                                                    localStorage.removeItem('mailreceived');
                                                                    localStorage.setItem('composenewclicked', 'false');
                                                                    navigate('/desktop/student/mailbox/view');
                                                                }}>
                                                                <div className="flex justify-between">
                                                                    <p className="text-black text-[12px] md:text-[18px] lg:text-[20px] xl:text-[15px] 2xl:text-[17px] font-bold">{mail.other === penpalEmail ? "Penpal" : (mail.other === teacherEmail ? "Teacher" : (mail.other === adminMail ? "Admin" : "Old penpal"))}</p>
                                                                    <p className="text-black text-[12px] md:text-[17px] lg:text-[19px] xl:text-[15px] 2xl:text-[17px]">{mail.sentAt.slice(0, -3)}</p>
                                                                </div>
                                                                <div className="hidden xl:block 2xl:hidden text-black text-[13px] md:text-[17px] xl:text-[15px]">
                                                                    {
                                                                        logDetails &&
                                                                        <>
                                                                            {
                                                                                mail.type === "PENPAL" && mail.initialSender !== logDetails.email ?
                                                                                    <p>{mail.translatedSubject.trim() !== "" ?
                                                                                        (mail.translatedSubject.length > 100
                                                                                            ? `${mail.translatedSubject.slice(0, 100)}...`
                                                                                            : mail.translatedSubject) : "(No subject)"}</p>
                                                                                    :
                                                                                    <p>{mail.subject.trim() !== "" ?
                                                                                        (mail.subject.length > 100
                                                                                            ? `${mail.subject.slice(0, 100)}...`
                                                                                            : mail.subject) : "(No subject)"}</p>
                                                                            }
                                                                        </>
                                                                    }
                                                                </div>
                                                                <div className="hidden 2xl:block text-black text-[13px] md:text-[17px] xl:text-[15px]">
                                                                    {
                                                                        logDetails &&
                                                                        <>
                                                                            {
                                                                                mail.type === "PENPAL" && mail.initialSender !== logDetails.email ?
                                                                                    <p>{mail.translatedSubject.trim() !== "" ?
                                                                                        (mail.translatedSubject.length > 140
                                                                                            ? `${mail.translatedSubject.slice(0, 140)}...`
                                                                                            : mail.translatedSubject) : "(No subject)"}</p>
                                                                                    :
                                                                                    <p>{mail.subject.trim() !== "" ?
                                                                                        (mail.subject.length > 140
                                                                                            ? `${mail.subject.slice(0, 140)}...`
                                                                                            : mail.subject) : "(No subject)"}</p>
                                                                            }
                                                                        </>
                                                                    }
                                                                </div>
                                                            </div>
                                                        ))}

                                                </div>
                                            }
                                            {
                                                folderSelected.draft &&
                                                <div className="mt-6">
                                                    {filteredEmailsDraft.slice()
                                                        .sort((a, b) => new Date(b.sentAtOriginal).getTime() - new Date(a.sentAtOriginal).getTime())
                                                        .map((mail, index) => (
                                                            <div key={index} className={`cursor-pointer flex flex-col ${(localStorage.getItem('nowreading') === `${index}` ? 'bg-[#FEFBE8]' : 'bg-transparent')} border-t border-t-[#C6CFD7] p-[10px]`}
                                                                onClick={() => {
                                                                    localStorage.setItem('nowreading', index);
                                                                    const mailRequest = {
                                                                        type: 'draft',
                                                                        threadId: mail.threadId,
                                                                        subject: mail.subject,
                                                                        to: mail.other,
                                                                        attachments: mail.attachments,
                                                                        messageId: mail.messageId,
                                                                        body: mail.body,
                                                                        role: mail.type
                                                                    };
                                                                    localStorage.setItem('threadId', JSON.stringify(mailRequest));
                                                                    localStorage.setItem("refresh", `${Date.now()}`);
                                                                    if (isXlOrLarger) {

                                                                        navigate('/desktop/student/mailbox');
                                                                        // navigate(`/StudentEmailReadPageDesktop`, { replace: true });
                                                                    } else {
                                                                        navigate('/mobile/student/mailbox/composemail');
                                                                    }
                                                                }} >
                                                                <div className="flex justify-between">
                                                                    <p className="text-black text-[12px] md:text-[18px] lg:text-[20px] xl:text-[15px] 2xl:text-[17px] font-bold">{mail.other === penpalEmail ? "Penpal" : (mail.other === teacherEmail ? "Teacher" : (mail.other === adminMail ? "Admin" : "Old penpal"))}</p>
                                                                    <p className="text-black text-[12px] md:text-[17px] lg:text-[19px] xl:text-[15px] 2xl:text-[17px]">{mail.sentAt.slice(0, -3)}</p>
                                                                </div>

                                                                <div className="hidden xl:block 2xl:hidden text-black text-[13px] md:text-[17px] xl:text-[15px]">
                                                                    {
                                                                        logDetails &&
                                                                        <>
                                                                            {
                                                                                mail.type === "PENPAL" && mail.initialSender !== logDetails.email ?
                                                                                    <p>{mail.translatedSubject.trim() !== "" ?
                                                                                        (mail.translatedSubject.length > 100
                                                                                            ? `${mail.translatedSubject.slice(0, 100)}...`
                                                                                            : mail.translatedSubject) : "(No subject)"}</p>
                                                                                    :
                                                                                    <p>{mail.subject.trim() !== "" ?
                                                                                        (mail.subject.length > 100
                                                                                            ? `${mail.subject.slice(0, 100)}...`
                                                                                            : mail.subject) : "(No subject)"}</p>
                                                                            }
                                                                        </>
                                                                    }
                                                                </div>
                                                                <div className="hidden 2xl:block text-black text-[13px] md:text-[17px] xl:text-[15px]">
                                                                    {
                                                                        logDetails &&
                                                                        <>
                                                                            {
                                                                                mail.type === "PENPAL" && mail.initialSender !== logDetails.email ?
                                                                                    <p>{mail.translatedSubject.trim() !== "" ?
                                                                                        (mail.translatedSubject.length > 140
                                                                                            ? `${mail.translatedSubject.slice(0, 140)}...`
                                                                                            : mail.translatedSubject) : "(No subject)"}</p>
                                                                                    :
                                                                                    <p>{mail.subject.trim() !== "" ?
                                                                                        (mail.subject.length > 140
                                                                                            ? `${mail.subject.slice(0, 140)}...`
                                                                                            : mail.subject) : "(No subject)"}</p>
                                                                            }
                                                                        </>
                                                                    }
                                                                </div>
                                                            </div>
                                                        ))}

                                                </div>
                                            }
                                        </div>

                                    </div> :
                                    <div className="bg-[#F7FAFB] px-[10px] py-[10px] mt-[20px]">
                                        <div className="flex flex-col  justify-start w-full">
                                            <p className={`text-start font-bold ml-[10px] text-[#1E2533] ${lang === "en" ? "xl:text-[24px] 2xl:text-[28px]" : (lang === "si" ? "xl:text-[17px] 2xl:text-[18px]" : "xl:text-[18px] 2xl:text-[18px]")}`}>
                                                {t('t233')}
                                            </p>
                                            <img src='/images/compose_mail.svg' alt="No mails" className="w-[150px] h-[150px] xl:w-[360px] xl:h-[360px] 2xl:w-[570px] 2xl:h-[570px] mx-auto mt-[20px]" />
                                            <p className={`text-center ml-[10px] mt-[10px] 2xl:mt-[20px]  text-[#000000] font-[700] ${lang === "en" ? " xl:text-[15px] 2xl:text-[20px]" : (lang === "si" ? "xl:text-[13px] 2xl:text-[15px]" : "xl:text-[13px] 2xl:text-[15px]")}`}>{t('t470')}</p>
                                            <div className="w-full flex justify-center">
                                                <div className="flex flex-col items-center mt-[5px] 2xl:mt-[10px] w-[500px] 2xl:w-[650px]">
                                                    <p className={`text-center ml-[10px]  text-[#000000] font-[500] ${lang === "en" ? " xl:text-[12px] 2xl:text-[17px]" : (lang === "si" ? "xl:text-[10px] 2xl:text-[12px]" : "xl:text-[10px] 2xl:text-[12px]")}`}>{t('t471')}</p>
                                                    <p className={`text-center ml-[10px]  text-[#000000] font-[500] ${lang === "en" ? " xl:text-[12px] 2xl:text-[17px]" : (lang === "si" ? "xl:text-[10px] 2xl:text-[12px]" : "xl:text-[10px] 2xl:text-[12px]")}`}>{t('t472')}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                            }
                        </div>
                }
            </div>
            <Dialog
                open={openError}
                onClose={handleCloseError}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogTitle
                    id="custom-dialog-title"
                    className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                >
                    {t('t95')}
                </DialogTitle>
                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {error}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleCloseError}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t96')}
                    </Button>
                </DialogActions>
            </Dialog>


        </div>
    );
}

export default EmailInbox;